module.exports = __webpack_public_path__ + "static/4b3b1aa60b83c9c06bc94978b2b6b2513d3e1849505903be4c5bac2277be18fb-e4c3ea95d28e2be77211ffd7ccb7bf12.png";